import { AnalyticsOptions } from 'owa-analytics';
import { AWT } from '@aria/webjs-compact-sdk';
import { AWTLogger, AWTLogManager } from '@aria/webjs-sdk';
import { getLogger } from 'owa-analytics/lib/AriaWrapper';
import { getMiniAnalyticsOptions } from 'mini-app-analytics';
import { listenMessageFromExtension } from './listenMessageFromExtension';
import { MessageResponseTypes } from '../schema/ResponseMessageTypes';
import { storeGUID } from 'data/lib/utils/deviceGUIDUtils';

const CORRELATION_ID_KEY_NAME = 'CorrelationId';

export default function initializeDeviceGUIDListener() {
    listenMessageFromExtension((event: MessageEvent) => {
        const { type, payload = {} } = event.data;
        if (type !== MessageResponseTypes.DeviceGUID) {
            return;
        }

        // Sets DeviceGUID obtained from extension as CorrelationId for all telemetry logs
        const { GUID } = payload;
        AWT.setContext(CORRELATION_ID_KEY_NAME, GUID);
        AWTLogManager.setContext(CORRELATION_ID_KEY_NAME, GUID);

        const miniAnalyticsOptions: AnalyticsOptions = getMiniAnalyticsOptions();
        const miniAriaToken: string = miniAnalyticsOptions.ariaTenantTokens[0];
        const miniLogger: AWTLogger = getLogger(miniAriaToken);
        miniLogger.setContext(CORRELATION_ID_KEY_NAME, GUID);

        // Stores DeviceGUID for further reference
        storeGUID(GUID);
    });
}
